import { useEffect, useState } from "react";

export default function ClientList() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/api/clients/all")
      .then((res) => res.json())
      .then((data) => {
        setClients(data.clients || []);
        setLoading(false);
      });
  }, []);

  if (loading) return <p className="text-center">Loading clients...</p>;

  if (clients.length === 0) {
    return <p className="text-center text-gray-500">No clients found.</p>;
  }

  return (
    <div className="max-w-5xl mx-auto mt-10 bg-white rounded-xl shadow p-6">
      <h2 className="text-xl font-bold mb-4 text-[#785f14]">Client List</h2>
      <table className="w-full table-auto border-collapse text-sm sm:text-base">
        <thead>
          <tr className="bg-gray-100">
            <th className="border px-4 py-2 text-left">Name</th>
            <th className="border px-4 py-2 text-left">Phone</th>
            <th className="border px-4 py-2 text-left">Email</th>
            <th className="border px-4 py-2 text-left">Products</th>
          </tr>
        </thead>
        <tbody>
          {clients.map((client) => (
            <tr key={client.id}>
              <td className="border px-4 py-2">
                {client.firstname} {client.lastname}
              </td>
              <td className="border px-4 py-2">{client.phone}</td>
              <td className="border px-4 py-2">{client.email}</td>
              <td className="border px-4 py-2">
                {client.products.length > 0 ? (
                  <ul className="list-disc ml-4 space-y-1">
                    {client.products.map((p, i) => (
                      <li key={i}>
                        <strong>{p.website}</strong> – {p.description}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <span className="text-gray-500 italic">No products</span>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
